document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    }));
  }

  document.querySelectorAll('[data-product-root]').forEach(root => {
    const json = root.querySelector('[data-product-json]');
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    if (!json || !select || !price) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch(e) { return; }
    select.addEventListener('change', () => {
      const variant = variants.find(v => String(v.id) === String(select.value));
      if (!variant) return;
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      try { price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency }).format(variant.price / 100); } catch(e) {}
    });
  });
});